import { Grid, Stack, Typography } from "@mui/material";
import ProSelectInput from "../../../../Components/Inputs/SelectField";
import ProTextInput from "../../../../Components/Inputs/TextField";
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";
import FileUploadField from "../../../../Components/Inputs/FileUploadField";

const ProjectSitePermittingEntitlementSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  projectDocumentTypeList,
  documentPath,
  documentFileName,
  setValue,
  setDocumentFileName,
  setDocumentUrl,
  handleDownload,
  convertFileToBase64,
  errorToast
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    { key: "permittingAuthority", type: "text" },
    { key: "heightLimit", type: "text" },
    { key: "projectDocumentType", type: "select", options: projectDocumentTypeList },
    { key: "projectDocumentFile", type: "file" }
  ];

  const renderField = ({ key, type, options }) => {
    const config = formConfig[key];
    const permission = fieldPermission(key);
    const commonProps = {
      key,
      ...defaultFormProps,
      ...config,
      permission
    };

    if (type === "select") return <ProSelectInput {...commonProps} options={options} />;
    if (type === "file")
      return (
        <FileUploadField
          {...commonProps}
          inputProps={{ accept: "" }}
          onChange={async e => {
            try {
              const file = e.target?.files?.[0];
              setValue("projectDocumentFile", file);

              if (!file) {
                setDocumentUrl("");
                setDocumentFileName("");
                return;
              }

              setDocumentFileName(file.name);
              const cleanedDataUrl = await convertFileToBase64(file);
              setDocumentUrl(cleanedDataUrl);
            } catch (error) {
              errorToast(error);
            }
          }}
        />
      );

    return <ProTextInput {...commonProps} />;
  };

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible defaultClose title="Project Site: Permitting & Entitlement Detail">
        {fields.map(renderField)}

        {documentPath && (
          <Grid item xs={12} md={6}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="subtitle1">Download File:</Typography>
              <Typography onClick={handleDownload} sx={{ cursor: "pointer", color: "blue" }} variant="body1">
                {documentFileName}
              </Typography>
            </Stack>
          </Grid>
        )}
      </FormSectionWrapper>
    )
  );
};

export default ProjectSitePermittingEntitlementSection;
